import React from 'react';

const Newsletter = () => {
  return (
    <section className="relative py-16 bg-[#F2B705] overflow-hidden">
      {/* دوائر زخرفية خفيفة بروح الملصقات */}
      <div aria-hidden="true" className="absolute -top-10 -right-10 w-40 h-40 rounded-full bg-white/10" />
      <div aria-hidden="true" className="absolute -bottom-16 -left-10 w-56 h-56 rounded-full bg-white/10" />

      <div className="container mx-auto px-4 relative">
        <div className="max-w-2xl mx-auto text-center">
          <div className="mb-6">
            <span className="inline-flex items-center justify-center w-16 h-16 mx-auto mb-4 rounded-full bg-[#1B1B1F]">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="w-7 h-7 text-white"
              >
                <rect width="20" height="16" x="2" y="4" rx="2" />
                <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" />
              </svg>
            </span>
            <h2
              className="text-3xl font-extrabold text-[#1B1B1F] mb-3"
              style={{ fontFamily: "'Baloo Bhaijaan 2', sans-serif" }}
            >
              اشترك في النشرة الإخبارية
            </h2>
            <p className="text-lg text-[#1B1B1F]/80">
              احصل على أحدث العروض والخصومات الحصرية مباشرة في بريدك الإلكتروني
            </p>
          </div>
          <form className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto" onSubmit={(e) => e.preventDefault()}>
            <input
              type="email"
              required
              placeholder="أدخل بريدك الإلكتروني"
              className="flex-1 bg-white border-0 text-[#1B1B1F] placeholder-gray-500 px-4 py-2.5 rounded-full
                focus:outline-none focus:ring-2 focus:ring-[#1B1B1F]"
            />
            <button
              type="submit"
              className="inline-flex items-center justify-center whitespace-nowrap rounded-full text-sm font-bold
                transition-colors bg-[#1B1B1F] hover:bg-white hover:text-[#1B1B1F] text-white px-8 py-2.5
                focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-[#F2B705]"
            >
              اشترك
            </button>
          </form>
          <p className="text-sm text-[#1B1B1F]/70 mt-4">
            لا تقلق، لن نرسل لك رسائل مزعجة. يمكنك إلغاء الاشتراك في أي وقت.
          </p>
        </div>
      </div>
    </section>
  );
}
export default Newsletter;
